/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Active` - ACTIVE
 * * `Next` - NEXT
 * * `Backlog` - BACKLOG
 * * `Finished` - FINISHED
 * * `Custom` - CUSTOM
 */
export enum DartboardKind {
  ACTIVE = 'Active',
  NEXT = 'Next',
  BACKLOG = 'Backlog',
  FINISHED = 'Finished',
  CUSTOM = 'Custom',
}
